import VideoPlayer_WithConsentWrapperComponent from '@wix/thunderbolt-elements/src/components/VideoPlayer/viewer/skinComps/WithConsentWrapper/WithConsentWrapper.skin';
import VideoPlayer_WithConsentWrapperController from '@wix/thunderbolt-elements/src/components/VideoPlayer/viewer/VideoPlayer.controller';


const VideoPlayer_WithConsentWrapper = {
  component: VideoPlayer_WithConsentWrapperComponent,
  controller: VideoPlayer_WithConsentWrapperController
};


export const components = {
  ['VideoPlayer_WithConsentWrapper']: VideoPlayer_WithConsentWrapper
};

